module.exports = __webpack_public_path__ + "img/group_bg.2f7a0374.png";